import {
    Component,
    OnInit,
    Input,
    ViewChild,
} from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { RightSideDrawerService } from '../right-side-drawer.service';
import {
    FormGroup,
    FormBuilder,
    Validators,
} from '@angular/forms';
import { SessionService } from '../../session-service/session.service';
import {
    debounceTime,
    switchMap,
    tap,
} from 'rxjs/operators';
import { ToastrService } from '@kpmg-tax/ui';

import { DatePipe } from '@angular/common';
// import { Options, ChangeContext } from '@angular-slider/ngx-slider';
import { EditExpenseSurveyService } from './edit-expense-survey.service';
import { AssignRespondentInput, Respondent } from '../../models/Respondent';
import { AssignSurveyRespondentService } from '../assign-survey-respondent/assign-survey-respondent.service';
import { CreateStudyService } from '../create-study/services/create-study.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { role } from '../../constants/role-enum';

@Component({
    selector: 'edit-expense-survey',
    templateUrl: './edit-expense-survey.component.html',
    styleUrls: ['./edit-expense-survey.component.scss'],
})
export class EditExpenseSurveyComponent
    implements OnInit {
    emailReminderFrequencyOptions: any = {
        floor: 0,
        ceil: 10,
        getPointerColor: (value: number): string => {
            if (value === 0) {
                return 'red';
            } else {
                return '#28a745';
            }
        }
    };
    engagementId: number;
    expenseSurveyDetail: any;
    targetForm: FormGroup;
    isNameChanged: boolean = false;
    surveyNameCopy: string;
    dueDate: Date = null;
    isDisabled: boolean = true;
    reminderValue: any;
    minDate: Date = new Date();
    @Input() survey: number;
    noResults: boolean = false;
    isSMESelected: boolean = false;
    filteredSurveyRespondents: any = null;
    surveyRespondents: Array<Respondent>;
    kpmgUsers: any[] = [];
    surveyRespondentsDemo: any[];
    addUserName: string = '';
    adSME: boolean = false;
    @ViewChild('dpDueDate', { static: true }) dpDueDate;
    clientName: string;
    surveyRepondent: AssignRespondentInput;
    showAddUserModel: boolean = false;
    respondentName: string;
    respondentSelected: any[] = [];
    respondentSelectedbckup: any[] = [];
    respondentData: any;
    deletedRespondents: any[] = [];
    targetFormSubmitted: boolean;
    surveyDetailsPostData: any;
    subscriptions: Subscription[] = [];
    isSmeUser = false;
    
    constructor(private _userDataService: UserDataService,
        public _rightSideDrawerService: RightSideDrawerService,
        public sessionService: SessionService,
        private _assignSurveyRepondentService: AssignSurveyRespondentService,
        private _editExpenseSurveyService: EditExpenseSurveyService,
        private _toastrService: ToastrService,
        private formBuilder: FormBuilder,
        public datepipe: DatePipe,
        private _createStudyService: CreateStudyService) {
        this.engagementId = Number(this.sessionService.getSession('engagementId'));
        this._assignSurveyRepondentService
            .getSurveyRespondent(this.sessionService.getSession('clientId'))
            .subscribe((response: any) => {
                this.surveyRespondents = response.result;
            });

    }

    ngOnInit() {
        this.expenseSurveyDetail = this._editExpenseSurveyService.expenseSurveyDetails;
        this.respondentData = this.expenseSurveyDetail.smEs;
        this.surveyNameCopy = this.expenseSurveyDetail.expenseSurveyName;
        this.clientName = this.sessionService.getSession('clientName');
        this.targetForm = this.formBuilder.group({
            expenseSurveyID: [''],
            expenseSurveyName: ['', Validators.required],
            //respondentName: ['', Validators.required],
            reminderFrequency: [
                0,
                [Validators.required, Validators.pattern('^([0-9]|1[0-4])$')],
            ],
            dueDate: [''],
        });

        setTimeout(() => {
            this.targetForm.patchValue({
                expenseSurveyID: this.expenseSurveyDetail.expenseSurveyID,
                expenseSurveyName: this.expenseSurveyDetail && this.expenseSurveyDetail.expenseSurveyName ? this.expenseSurveyDetail.expenseSurveyName.trim().substring(0, 100) : this.expenseSurveyDetail.expenseSurveyName,
                reminderFrequency: this.expenseSurveyDetail.reminders,
                //respondentName: this.respondentDetails.respondentName,
                dueDate: this.datepipe.transform(
                    this.expenseSurveyDetail.dueDate,
                    'MM/dd/yyyy',
                ),
            });
            this.reminderValue = this.expenseSurveyDetail.reminderFrequency;
            //this.respondentSelected.push(this.respondentDetails.respondentName);
        });
        this.getKPMGUsers();
        if (this.respondentData != null) {
            this.respondentData.forEach(element => {
                let initialRespondent = {
                    displayName: element.displayName,
                    engagementId: element.engagementId,
                    surveyId: element.surveyId,
                    userId: element.userId,
                    isReassign: this.expenseSurveyDetail.isReassign,
                };
                this.respondentSelected.push(initialRespondent);
                this.respondentSelected = [...this.respondentSelected];
                this.respondentSelectedbckup.push(initialRespondent);
            });
        }

        this.subscriptions.push(this._userDataService.userDetails$.subscribe(userData => {
            if (userData) {
              if (userData.roleId === role.respondent) {
                this.targetForm.controls['dueDate'].disable();
                this.isSmeUser = true;
              }
            }
          }))
    }


    public noWhitespaceValidator() {
        let control = this.targetForm.controls['expenseSurveyName'];
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : control.setErrors({ incorrect: true });
    }
    trimSpecialChar(ctrl: any) {
        this.targetForm.controls[ctrl].setValue(
            this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
        );
        //this.isChanged();
    }
    closeRightSideDrawer() {
        this.surveyRepondent = null;
        this._rightSideDrawerService.closeRightSideDrawer();
    }
    get f() {
        return this.targetForm?.controls;
    }
    checkChangeName() {
        if (this.targetForm.value.expenseSurveyName !== this.surveyNameCopy) {
            this.isNameChanged = true;
        } else {
            this.isNameChanged = false;
        }
    }
    isChanged() {
        let respondent = {
            sName:
                this.targetForm.get('expenseSurveyName').value === null
                    ? ''
                    : this.targetForm.get('expenseSurveyName').value,

            reminderFrequency: this.targetForm.get('reminderFrequency').value,
            dueDate: this.targetForm.get('dueDate').value,
        };

        let expenseSurveyName = this.expenseSurveyDetail.expenseSurveyName.replace(/[^a-zA-Z0-9-()._/ ]/g, '').trim();
        let respondentSName = respondent.sName.replace(/[^a-zA-Z0-9-()._/ ]/g, '').trim();
        let dueDateOriginal = this.datepipe.transform(
            this.expenseSurveyDetail.dueDate,
            'MM/dd/yyyy',
        );
        let dueDate = this.datepipe.transform(this.dueDate, 'MM/dd/yyyy');

        if (
            respondentSName !== expenseSurveyName ||
            // respondent.SME !== this.respondentDetails.respondentName ||
            respondent.reminderFrequency !== this.expenseSurveyDetail.reminders ||
            dueDateOriginal !== dueDate
        ) {
            this.isDisabled = false;
            this._rightSideDrawerService.setMandatoryField(true, 'Edit Survey');
        } else {
            this.isDisabled = true;
            this._rightSideDrawerService.setMandatoryField(false, '');
        }
    }

    setDueDate(date: Date) {
        this.dueDate = date;
        this.isChanged();
    }
    clearDueDate() {
        this.targetForm.controls.dueDate.setValue(null);
        this.isChanged();
    }
    openDatePickerEnd() {
        this.dpDueDate.toggle();
    }
    respondentFormatter(result: any) {
        return '';
    }
    // sliderEvent(changeContext: ChangeContext) {
    //     this.isChanged();
    // }
    private searchingRespondent(term: any): Observable<any> {
        if (term) {
            this.isSMESelected = true;
        } else {
            this.isSMESelected = false;
        }
        if (this.surveyRespondents == null) {
            return of([]);
        }
        return of(
            this.surveyRespondents.filter(item =>
                item.displayName.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }
    private searchingDemoRespondent(term: any): Observable<any> {
        let kpmgUserdata: any[] = this.kpmgUsers;
        let surveyRespondentsData: any[] = this.surveyRespondents;
        this.surveyRespondentsDemo = kpmgUserdata.concat(surveyRespondentsData);
        if (term) {
            this.isSMESelected = true;
        } else {
            this.isSMESelected = false;
        }
        if (surveyRespondentsData == null && kpmgUserdata == null) {
            return of([]);
        } else if (surveyRespondentsData == null && kpmgUserdata != null) {
            return of(
                kpmgUserdata.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else if (surveyRespondentsData != null && kpmgUserdata == null) {
            return of(
                surveyRespondentsData.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of(
                this.surveyRespondentsDemo.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        }
    }

    //getKPMGUsers(): any {
    //    this._homeCreateNewEngagementService.GetKPMGUsers().subscribe((users: BaseResponse) => {
    //        this.kpmgUsers = users.result;
    //    });
    //}

    getKPMGUsers(): void {
        this._createStudyService.kpmgUsersDataSource$.subscribe(kpmgUsersResponse => {
            if (kpmgUsersResponse && kpmgUsersResponse.result) {
                this.kpmgUsers = kpmgUsersResponse.result;
            }
        });
    }

    onRespondentSelected(respondent: any) {
        if (respondent.item.displayName.includes('Click here to add user.')) {
            //this.clientName = this.respondentName.ClientName;
            //this.respondentName = '';
            respondent.item.displayName = '';
            this.respondentName = '';
            this.showAddUserModel = true;

            console.log('model open');
        } else {
            this.respondentName = respondent.item.displayName;
            this.surveyRepondent = {
                displayName: respondent.item.displayName,
                engagementId: Number(this.sessionService.getSession('engagementId')),
                surveyId: this.survey,
                userId: respondent.item.userId,
                isReassign: this.expenseSurveyDetail.isReassign,
            };
            let index = this.respondentSelected.findIndex(
                item => item.userId === this.surveyRepondent.userId,
            );
            if (index !== -1) {
                return;
            }
            let deletedIndex = this.deletedRespondents.findIndex(
                item => item.userId === this.surveyRepondent.userId,
            );
            if (deletedIndex !== -1) {
                this.deletedRespondents.splice(deletedIndex, 1);
            }
            this.respondentSelected.push(this.surveyRepondent);
            this.respondentSelected = [...this.respondentSelected];

            let found = this.respondentSelected.every(i => this.respondentSelectedbckup.includes(i));
            if (found) {
                this.isDisabled = true;
                //this.isSMESelected = false;
            } else {
                this.isDisabled = false;
                //this.isSMESelected = true;

            }


        }
    }

    removeRespondent(row: any) {
        let removeIndex = this.respondentSelected.findIndex(
            item => item.userId === row.userId,
        );
        let respondentDeleted = this.respondentSelected.filter(e => e.userId == row.userId);
        this.deletedRespondents.push(respondentDeleted[0]);
        this.deletedRespondents = [...this.deletedRespondents];
        // let found = this.respondentSelectedbckup.findIndex(
        //   el => el.userId != row.userId,
        // );

        this.respondentSelected.splice(removeIndex, 1);
        this.respondentSelected = [...this.respondentSelected];
        let found = this.respondentSelectedbckup.every(i => this.respondentSelected.includes(i));
        if (!found) {
            //this.isSMESelected = true;
            this.isDisabled = false;
        } else {
            //this.isSMESelected = false;
            this.isDisabled = true;
        }
        if (this.respondentSelected.length === 0) {
            this.isSMESelected = false;
        }
        console.log(this.respondentSelected);
        // if(this.respondentSelected.length===0){
        //   this.isSMESelected = false;
        // }
    }

    searchRespondents = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            //distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                this.noResults = false;
            }),
            switchMap(term => {
                this.filteredSurveyRespondents = null;
                if (this.clientName != 'KPMG Demo') {
                    return this.searchingRespondent(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    clientId: null,
                                    clientName: null,
                                    email: null,
                                    displayName:
                                        'User' +
                                        ' ' +
                                        term +
                                        ' not found.' +
                                        ' ' +
                                        'Click here to add user.',
                                },
                            ];
                            this.noResults = data.length === 0;
                            console.log(data);
                            if (this.noResults === true && term !== '') {
                                this.adSME = true;
                                this.addUserName = term;
                                return of(noData);
                            } else {
                                return of(data);
                            }
                        }),
                    );
                } else if (this.clientName == 'KPMG Demo') {
                    return this.searchingDemoRespondent(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    clientId: null,
                                    clientName: null,
                                    email: null,
                                    displayName:
                                        'User' +
                                        ' ' +
                                        term +
                                        ' not found.' +
                                        ' ' +
                                        'Click here to add user.',
                                },
                            ];
                            this.noResults = data.length === 0;
                            console.log(data);
                            if (this.noResults === true && term !== '') {
                                this.adSME = true;
                                this.addUserName = term;
                                return of(noData);
                            } else {
                                return of(data);
                            }
                        }),
                    );
                } else {
                    return of([]);
                }
            }),
        )


    submitData() {
        // this.isDisabled = true;
        // if (this.isNameChanged) {
        //   let engagementId = Number(this.sessionService.getSession('engagementId'));
        //   let sName = this.targetForm.value.surveyName;
        //   this._assignSurveyRepondentService
        //     .CheckSurveyNameExists(engagementId, sName)
        //     .subscribe((data: any) => {
        //       if (!data.result) {
        //         this.updateSurveyMetaData();
        //       } else {
        //         this._toastrService.setErrorMessage(data.errorMessage);
        //         this.isDisabled = false;
        //       }
        //       this.targetFormSubmitted = true;
        //     });
        // } else {
        //   this.updateSurveyMetaData();
        // }
        //   this._rightSideDrawerService.closeRightSideDrawer();

    }

    updateSurveyMetaData() {
        // this._assignSurveyRepondentService
        //   .updateSurveyMetadata(this.cleanTargetFormToPost())
        //   .subscribe((data: any) => {
        //     if (data.result) {
        //       this.respondentData = this.expenseSurveyDetail.smEs;
        //       this._editExpenseSurveyService.setExpenseSurveyDetails(
        //         this.expenseSurveyDetail,
        //       );
        //       this.sessionService.setSession(
        //         'surveyDetails',
        //         JSON.stringify(this.expenseSurveyDetail),
        //       );
        //      // this._assignSurveyRepondentService.refreshData(this.expenseSurveyDetail);
        //       this._toastrService.setSuccessMessage(
        //         Messages.AssignSurveyRespondent.SURVEY_DETAILS_UPDATE_SUCCESS,
        //       );
        //     } else {
        //       this._toastrService.setErrorMessage(
        //         data.errorMessage,
        //         Messages.ErrorMessage,
        //       );
        //     }
        //   },
        //   error =>{
        //     this._toastrService.setErrorMessage(
        //       Messages.ErrorMessage,
        //     );
        //   });
    }

    // cleanTargetFormToPost = () => {
    //   let formData = this.targetForm.value;
    //   console.log(formData);
    //   formData.dueDate = this.datepipe.transform(
    //     this.targetForm.get('dueDate').value,
    //     'MM/dd/yyyy',
    //   );

    //   let selectedSmes=Array.prototype.map.call(this.respondentSelected, s => s.userId).toString();
    //   let deletedSmes=Array.prototype.map.call(this.deletedRespondents, s => s.userId).toString();
    //   let respondentDetails=
    //   {
    //     selectedSmes:selectedSmes,
    //     deletedSmes:deletedSmes

    //   }
    //   this.surveyDetailsPostData = {
    //     updateSurveyMetaDataRequestDTO: formData,
    //     surveyRespondentRequestDTO: respondentDetails,

    //   };
    //   this.expenseSurveyDetail.surveyName = formData && formData.surveyName ? formData.surveyName.trim().substring(0, 100) : formData.surveyName;
    //   this.expenseSurveyDetail.reminders = formData.reminderFrequency;

    //   this.expenseSurveyDetail.users = this.respondentSelected;
    //   if (
    //     typeof formData.respondentName === 'undefined' ||
    //     !formData.respondentName
    //   ) {
    //     this.expenseSurveyDetail.userName = '';
    //   } else {
    //     this.expenseSurveyDetail.userName =
    //       typeof formData.respondentName.userName === 'undefined'
    //         ? formData.respondentName
    //         : formData.respondentName.userName;
    //   }

    //   this.expenseSurveyDetail.dueDate = this.datepipe.transform(
    //     formData.dueDate,
    //     'MM/dd/yyyy',
    //   );
    //   this.surveyDetailsPostData.updateSurveyMetaDataRequestDTO.engagementId = Number(
    //     this.sessionService.getSession('engagementId'),
    //   );
    //   return this.surveyDetailsPostData;
    // }
}
